import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component, index) => {
    return (_openBlock(), _createBlock(_resolveDynamicComponent(component.type), _mergeProps({
      key: _ctx.getKey(component, index)
    }, component, {
      "view-mode": _ctx.viewMode,
      path: _ctx.buildPath(component),
      "client-side-events": component.client_side_events,
      settings: component.settings ?? {},
      "context-path": _ctx.contextPath
    }), null, 16, ["view-mode", "path", "client-side-events", "settings", "context-path"]))
  }), 128))
}